import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { JdsButton } from '../../../components/jds/JdsButton';
import '../../../components/jds/jds.css';
import '../clienteDados.css';

const STANDARD_REASONS = [
  'O usuário perdeu acesso ao email temporáriamente.',
  'O usuário perdeu acesso ao email definitivamente.',
];

export default function Disable2FAModal({
  show,
  onHide,
  onConfirm,
  user,
  loading,
}) {
  const [selectedReason, setSelectedReason] = useState('');
  const [customReason, setCustomReason] = useState('');

  useEffect(() => {
    if (!show) {
      setSelectedReason('');
      setCustomReason('');
    }
  }, [show]);

  const handleConfirm = () => {
    const reason = selectedReason === 'custom' ? customReason : selectedReason;
    if (reason) {
      onConfirm(reason);
    }
  };

  const isConfirmDisabled =
    loading ||
    !selectedReason ||
    (selectedReason === 'custom' && !customReason.trim());

  return (
    <Modal show={show} onHide={onHide} centered className="jds-scope">
      <Modal.Header closeButton>
        <Modal.Title>Desativar autenticação de dois fatores (2FA)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Você está prestes a desativar temporariamente o 2FA para o usuário{' '}
          <strong>{user?.name}</strong>. Por favor, selecione um motivo.
        </p>
        <Form>
          {STANDARD_REASONS.map((reason, index) => (
            <Form.Check
              type="radio"
              key={index}
              id={`reason-${index}`}
              label={reason}
              name="reason"
              value={reason}
              checked={selectedReason === reason}
              onChange={(e) => setSelectedReason(e.target.value)}
              className="mb-2"
            />
          ))}
          <Form.Check
            type="radio"
            id="reason-custom"
            label="Outro motivo (especificar abaixo)"
            name="reason"
            value="custom"
            checked={selectedReason === 'custom'}
            onChange={(e) => setSelectedReason(e.target.value)}
          />
          {selectedReason === 'custom' && (
            <Form.Group className="mt-2">
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Digite o motivo personalizado"
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
                autoFocus
              />
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <JdsButton
          variant="outlined"
          color="neutral"
          onClick={onHide}
          disabled={loading}
        >
          Cancelar
        </JdsButton>
        <JdsButton
          color="error"
          onClick={handleConfirm}
          disabled={isConfirmDisabled}
        >
          {loading ? 'Processando...' : 'Confirmar desativação'}
        </JdsButton>
      </Modal.Footer>
    </Modal>
  );
}
